// extracted by mini-css-extract-plugin
export default {"container":"styles_container__e7cCu","container__rigth":"styles_container__rigth__Qa5T5"};